import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notificationKeys, type NotificationPages } from '@entities/notification';
import { api, notificationEndpoints } from '@shared/api';

/**
 * 모두 읽음(`PUT /notifications/read` — 그 회원의 알림 전부, 받지 않은 쪽 포함). 캐시를 먼저 바꿔(낙관적)
 * 받은 줄 · 빨간 점이 바로 바뀐다. 실패하면 되돌린다. 실패 토스트는 띄우지 않는다(다음 조회에서 맞춰진다).
 */
export function useReadAllNotificationsMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.request(notificationEndpoints.readAllNotifications),
    meta: { silent: true },
    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey: notificationKeys.lists() });
      const previous = queryClient.getQueryData<NotificationPages>(notificationKeys.lists());
      queryClient.setQueryData<NotificationPages>(notificationKeys.lists(), (data) =>
        data
          ? {
              ...data,
              pages: data.pages.map((page) => ({
                ...page,
                unreadCount: 0,
                items: page.items.map((item) => ({ ...item, isRead: true })),
              })),
            }
          : data,
      );
      return { previous };
    },
    onError: (_error, _vars, context) => {
      if (context?.previous) queryClient.setQueryData(notificationKeys.lists(), context.previous);
    },
  });
}
